import React, { useEffect, useState, useContext } from "react";

import {
  OuterWrapper,
  BodyWrapperStyled,
  BoxStyled,
  CardStyled,
} from "../../theme";
import { Layout, useWindowSize } from "../layout/otherPage";
import { PointsReport } from "./pointsReport";
import { PdfContainer } from "../pdf/pdfContainer";
import { LanguageContext } from "../languageProvider";

export const GenerateReports = () => {
  const { wrapperHeight } = useWindowSize();
  const { lang } = useContext(LanguageContext);

  const [routePointsIds, setRoutePointsIds] = useState([]);
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState(true);

  // filter routesPointsId
  useEffect(() => {
    let ListToGenerateReport = localStorage.getItem("generateReport")
      ? JSON.parse(localStorage.getItem("generateReport"))
      : [];
    if (ListToGenerateReport.length > 0 && filter) {
      let list = [];
      let serviceOrder = [];
      for (let route of ListToGenerateReport) {
        for (let point of route.points) {
          list = [...list, { ...point, routeId: route.id }];
        }
      }
      for (let point of list) {
        if (point.serviceOrders.length > 0) {
          serviceOrder = [...serviceOrder, ...point.serviceOrders];
        }
      }
      setOrders(serviceOrder);

      setFilter(false);
      setRoutePointsIds(list);
    }
  }, [filter]);

  return (
    <Layout lang={lang}>
      <OuterWrapper height={wrapperHeight}>
        <BodyWrapperStyled fullHeight>
          <BoxStyled>
            <CardStyled>
              <PdfContainer serviceOrders={orders}>
                {routePointsIds.length > 0 &&
                  routePointsIds.map((point) => (
                    <PointsReport point={point} key={point.id} />
                  ))}
              </PdfContainer>
            </CardStyled>
          </BoxStyled>
        </BodyWrapperStyled>
      </OuterWrapper>
    </Layout>
  );
};
